import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Account } from '@personal-area/global/accounts/models';

import { AccountTypePipe } from '../../pipes/account-type.pipe';

@Component({
    selector: 'global-account-type-indicator',
    templateUrl: 'account-type-indicator.component.html',
    styleUrls: ['./account-type-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, AccountTypePipe]
})
export class AccountTypeIndicatorComponent {
  @Input() account?: Account;
}
